import { render, staticRenderFns } from "./TextListMultiValue.vue?vue&type=template&id=4cdc337e"
import script from "./TextListMultiValue.vue?vue&type=script&lang=ts"
export * from "./TextListMultiValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports